import React from "react";
import { getCurrentCulture } from "@utils";
import { THEME_SETTINGS } from "@theme-settings";
import { HeaderSpecialLink } from "./HeaderSpecialLink";

// NB: the default file contains links for TWSE
export default function HeaderSpecialLinks() {
	if (!THEME_SETTINGS.isHeaderIconsEnabled) {
		return null;
	}

	return (
		<div className="header__links">
			<HeaderSpecialLink
				icon="game-pause"
				title="Game pause"
				to="https://spelpaus.se"
			/>
			<HeaderSpecialLink
				icon="limit"
				title="Limit"
				to={`/${getCurrentCulture()}/account-settings/my-limits`}
				isInApp={true}
			/>
			<HeaderSpecialLink
				icon="self-test"
				title="Self test"
				to="https://stodlinjen.se/spelberoende-test-pgsi"
			/>
		</div>
	);
}
